import { render } from "./UserFormView.vue?vue&type=template&id=f1be383e&scoped=true"
import script from "./UserFormView.vue?vue&type=script&lang=js"
export * from "./UserFormView.vue?vue&type=script&lang=js"

import "./UserFormView.vue?vue&type=style&index=0&id=f1be383e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1be383e"]])

export default __exports__